<div class="mikrofon-velger">
  <mat-form-field>
    <mat-label>{{'Velg mikrofon'|translate}}</mat-label>
    <mat-select [(value)]="valgtDeviceId" panelClass="mikrofon-velger--alternativer">
      <mat-option [value]="null">{{'Standard mikrofon'|translate}}</mat-option>
      @for (enhet of enheter(); track enhet.deviceId) {
        <mat-option [value]="enhet.deviceId">{{ enhet.label || ('Microphone ' + enhet.deviceId) }}</mat-option>
      }
      <mat-divider/>
      <button mat-button color="primary" type="button" (click)="oppdaterEnheter()" class="oppdater-enheter-knapp">
        {{'Oppdater enheter'|translate}}
      </button>
    </mat-select>
    @if (mikrofonPulsFeil() != null) {
      <mat-error>{{ mikrofonPulsFeil() }}</mat-error>
    }
    <mat-hint>
      <mikrofon-puls [deviceId]="valgtDeviceId()" (vedFeil)="vedMikrofonPulsFeil($event)"/>
    </mat-hint>
  </mat-form-field>
</div>
